import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthRestService} from '@core/modules/rest/authentication/auth-rest.service';
import {ROOT_PUBLIC} from '@core/services/routes.service';

@Component({
    selector: 'app-info-page',
    templateUrl: './info-page.component.html',
    styleUrls: ['./info-page.component.scss']
})
export class InfoPageComponent implements OnInit {
    linkExpiredIcon = 'link_off';
    passwordSetIcon = 'password_set';
    icon: string;
    message: string;
    errorCode: string;

    constructor(private translateService: TranslateService, private route: ActivatedRoute, private authService: AuthRestService, private router: Router) {
    }

    ngOnInit(): void {
        this.route.queryParamMap.subscribe(params => {
            if (params.get('password')) {
                this.icon = this.passwordSetIcon;
                this.message = this.translateService.instant('INFO.PASSWORD_SET');
            } else if (params.get('token')) {
                this.icon = this.linkExpiredIcon;
                this.message = this.translateService.instant('INFO.LINK_EXPIRED');
            } else {
                this.message = this.translateService.instant('INFO.PAGE_NOT_FOUND');
                this.errorCode = '404';
            }
        });
    }

    onReturnToHome(): void {
        this.router.navigate([ROOT_PUBLIC]);
    }

}
